var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('general.welcome')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }